import { GET_LIST, GET_MANY, UPDATE } from 'react-admin';
import { providerRoleRequestToHttpRequest } from './roles.dataProvider';
import logger from '../utils/logger';
export const PROVIDER_ROLES_RESOURCE_NAME = 'provider.roles';

export const providerRequestToHttpRequest = (requestType, requestParams) => {
  return providerRoleRequestToHttpRequest(requestType, requestParams, true);
};

const httpResponseToProviderData = (
  httpResponse,
  requestType,
  requestParams,
) => {
  let { headers, json } = httpResponse;
  switch (requestType) {
    case GET_LIST:
      // // logger.log(PROVIDER_ROLES_RESOURCE_NAME, "response: ", json.map(roleItem => roleItem))
      return {
        data: json
          .map((roleItem) => roleItem)
          .filter((roleItem) => roleItem.is_provider_subtype === true),
        total: parseInt(headers.get('content-range').split('/').pop()),
      };
    case GET_MANY:
      let roleIdsToGet = requestParams.ids;
      //// logger.log("roles_provider handling ids => ", roleIdsToGet);
      //// logger.log(PROVIDER_ROLES_RESOURCE_NAME, "response: ", json.filter(roleItem => roleIdsToGet.includes(roleItem.id)))
      return {
        data: json
          .filter((roleItem) => roleIdsToGet.includes(roleItem.id))
          .filter((roleItem) => roleItem.is_provider_subtype === true),
      };
    case UPDATE:
      return {
        data: json,
      };
    default:
      return { data: json };
  }
};

export default {
  resource: PROVIDER_ROLES_RESOURCE_NAME,
  providerInterface: {
    providerRequestToHttpRequest,
    httpResponseToProviderData,
  },
};
